import { LabelHTMLAttributes } from "react";
import { label, LabelVariantProps } from "./label.variants";

export type UseLabelProps = LabelVariantProps &
  LabelHTMLAttributes<HTMLLabelElement> & {
    className?: string;
  };

export const useLabel = (props: UseLabelProps) => {
  const {
    className = "",
    children,
    hidden = false,
    color,
    ...componentProps
  } = props;

  const styles = label({ hidden, color });

  return {
    styles,
    className,
    children,
    componentProps,
  };
};
